// extracted by mini-css-extract-plugin
module.exports = {"changeCard":"ChangeLog_changeCard__Ee0JX","changeCardTitle":"ChangeLog_changeCardTitle__YV8yE","changeTableHeader":"ChangeLog_changeTableHeader__KT_2Y"};